import Vue from 'vue';
import { confManager, SpmDirective } from '@tencent/nb-web-reporter';
import spmMap from '@/spm/spm-map.json';
import { genUUID } from '@/utils/uuid';
import { querySearch } from '@tencent/nb-h5-tools/queryParser';
import { curEnv, ENV_ENUM } from '@tencent/nb-h5-tools/env';
import JsBridge from '@/utils/jsBridge/index';
// 当不运行在APP内时设为空,走普通上报
let customReport = null;
// platform默认为5,代表H5
let platformSpm = '5';
if (curEnv === ENV_ENUM.APP_ANDROID || curEnv === ENV_ENUM.APP_IOS) {
  // APP 环境内, 优先走 JsBridge 上报
  // 将参数封装成 Jsbridge 要求的格式
  const report = (eventName, reportParams) => JsBridge.Ares.report({
    event: eventName || '',
    params: reportParams || {},
  });
  // 封装一层对象,以便reporter接收
  customReport = {
    report,
  };
  // 修改当前平台为对应app
  platformSpm = curEnv;
}
// 从spm-map.json引入spm信息并处理,防止后续新增页面有遗漏
const spmConfig = {};
spmMap.forEach((item) => {
  const key = item.name;
  const value = Number(item.spm);
  spmConfig[key] = value;
});
// openlink页需要上报promotion
const pageReportParams = () => {
  const params = {
    event_uuid: genUUID(), // 事件ID
  };
  // 匹配当前页面名称
  const pageName = window.location.href.match(/\/([\w-_]+)\.html/);
  // openlink页特殊处理,上报携带promotion
  if (pageName && pageName[1] === 'openlink') {
    const ext = {
      promotion: querySearch('promotion') || '',
    };
    // 不属于公参的放入ext中
    params.ext = JSON.stringify(ext);
  }
  return params;
};
confManager.initReport({
  // 灯塔 H5 appkey
  appkey: '0WEB0XYTYC4JYTDO',
  // platform配置,代表当前平台
  platformSpm,
  // page 位 spm 的配置
  spmConfig,
  // 匹配 pageName 的方法,ares_h5认为是非SPA
  isSPA: false,
  // 自定义上报参数
  pageReportParams,
  // APP环境内的上报对象
  reporter: customReport,
});

// 注册自定义指令
Vue.use(SpmDirective);

